<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Std. Cost Studio/Equipment 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>

      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked" :key="tblData.limit"
      >
        <template v-slot:cell(stdcost)="data">
            {{(data.item.stdcost)|numFormat}}
        </template>
        <template v-slot:cell(liveprod)="data">
          <span v-if="(data.item.liveprod)">LIVE</span>
          <span v-else>TAPING</span>
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="2" >
            <b-input-group >
                <b-input-group-prepend><span  class="pt-1 mr-2">Limit per page</span></b-input-group-prepend>
                <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card>
          <div slot="header">TV Program - Add/Edit Form 
          </div>
                    <b-input-group >
                        <b-input-group-prepend><label>Studio/Equipment Package</label></b-input-group-prepend>
                        <b-form-select  v-model="frmdata.studiocode" :plain="true" :options="studiocodes" ></b-form-select>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Program Code</label></b-input-group-prepend>
                        <b-form-input v-model="frmdata.tablekey" :state="!$v.frmdata.tablekey.$error"></b-form-input>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Program Group</label></b-input-group-prepend>
                        <b-form-select style=" width: 50%;"  v-model="frmdata.groupprog" :plain="true" :options="groups" :state="!$v.frmdata.groupprog.$error"></b-form-select>
                        <b-input-group-prepend><span  class="pt-2 mr-2">&nbsp;&nbsp;&nbsp;&nbsp;Rate Spot</span></b-input-group-prepend>
                        <b-form-select  v-model="frmdata.spotrate" :plain="true" :options="spotrates" ></b-form-select>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>News Category/Dep</label></b-input-group-prepend>
                        <b-form-select  v-model="frmdata.newscateg" :plain="true" :options="newscategs" ></b-form-select>
                        <b-form-select class="ml-1" v-model="frmdata.newsdep" :plain="true" :options="newsdeps" ></b-form-select>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>LIVE Production</label></b-input-group-prepend>
                        <b-form-select  v-model="frmdata.studiocode" :plain="true" :options="studiocodes" ></b-form-select>
                        <b-input-group-append>
                                <span class="input-group-text">Studio/Equipment Std. Cost</span>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>TAPING Production</label></b-input-group-prepend>
                        <b-form-select  v-model="frmdata.studiotape" :plain="true" :options="studiotapes" ></b-form-select>
                        <b-input-group-append>
                                <span class="input-group-text">Studio/Equipment Std. Cost</span>
                        </b-input-group-append>
                    </b-input-group>

            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
             <b-button variant="secondary" class="mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>
        </b-card>
        </b-col>
      </b-row>

  </div>
</template>

<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 160px;
            }
        }
    }
</style>


<script>
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        nama: { required },
        tablekey: { required },
        groupprog: { required },
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      showList:true,
      showForm:false,
      frmdata:{tablekey:'',nama: '',groupprog:'',newscateg:'' },
      studiocodes:[],
      tblData: {
        tablename:'vwstudiorate',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false
      },
      filter:{ nama:'', groupname:''}
    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "studioname",
            label: "Studio/Equipment Package",
            sortable: true
          },
          {
            key: "liveprod",
            label: "Program Group",
            sortable: true
          },
          {
            key: "stdcost",
            label: "Std. Cost",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  created: async function () {
        const [a] = await Promise.all([
          crud.list({
            tablename:'studio',
            page: 1,
            limit: 1000,
            total: 0,
            sortBy: 'nama',
            sortDesc: false
          }),
          ]);
        this.studiocodes = a.reduce((newArr,item) =>{
            newArr.push({ value: item.kode, text: item.nama});
            return newArr;
        },[]);
        // this.filtergroups = a.reduce((newArr,item) =>{
        //     newArr.push({ value: item.kode, text: item.nama});
        //     return newArr;
        // },[{value:'', text:'--ALL--'}]);
        // this.filtergroups=this.filtergroups.concat(this.groups);
  },
  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      // this.tblData.customQuery='';
      // let str;
      // if (this.filter.nama){
      //   str = 'nama=%' + encodeURIComponent(this.filter.nama)+'%';
      // }
      // if (this.filter.groupname){
      //   str += str ? '&' : '';
      //   str = 'groupprog=' + encodeURIComponent(this.filter.groupname);
      // }
      // this.tblData.customQuery=str;

      const list = await crud.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.filter.nama= '';
        this.filter.groupname= '';
        this.refresh();
    },

    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.frmdata.idlama = data.tablekey;
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              if (this.frmdata.idlama) {
                await crud.update(
                     {tablename:'studiorate', 
                     key:this.frmdata.idlama, 
                     data:{stdcost:this.frmdata.stdcost,liveprod:this.frmdata.liveprod, studiocode:this.frmdata.studiocode}
                      });
              } else {
                await crud.insert(
                  { tablename:'studiorate',                      
                     data:{stdcost:this.frmdata.stdcost,liveprod:this.frmdata.liveprod, studiocode:this.frmdata.studiocode}
                  });
              }
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({tablename:'studiorate', key:this.model.tablekey});
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
